
import ImgDsDark from 'assets/img/ds-dark.svg';
import Imghk from 'assets/img/hk.png';
import { Link } from 'react-router-dom'
import ReactTooltip from 'react-tooltip';

function NavBar() {
    return (
        <>
            <ReactTooltip />
            <div className="d-flex flex-column flex-md-row align-items-center p-3 px-md-4 mb-3 bg-light border-bottom shadow-sm">
                <div className="container">
                    <nav className="my-2 my-md-0 mr-md-3">
                        <Link data-tip="Home" to="/">
                            <img src={ImgDsDark} alt="DevSuperior" width="120" />
                        </Link>
                        <div className="">
                            <img src={Imghk} alt="DevSuperior" width="25" />
                            <b id="nomeHome">Miguel Silva</b>
                        </div>
                    </nav>
                </div>
            </div>
        </>
    );
}

export default NavBar;